import { print } from 'graphql';
import getCart from './cart.graphql';
import getActiveDeliveryIdsInOrder from './activeDeliveryIds.graphql';
import getVariants from './variants.graphql';
import getFavoriteLists from './favorites.graphql';

export default {
  getCartWithVariants: print(getCart),
  activeDeliveryIdsInCart: print(getActiveDeliveryIdsInOrder),
  getVariants: print(getVariants),
  getFavoriteLists: print(getFavoriteLists),
};
